export const LOADING_CHANGE = 'LOADING_CHANGE';
export const DATA = "DATA";
export const DATA_CONCAT = "DATA_CONCAT";
export const DATA_WITH_PAGINATION = "DATA_WITH_PAGINATION";
export const SET_FIELDS = 'SET_FIELDS';
export const SET_ERROR_FORMS = 'SET_ERROR_FORMS';